import { render, staticRenderFns } from "./single-option.vue?vue&type=template&id=f15106ca"
import script from "./single-option.vue?vue&type=script&lang=js"
export * from "./single-option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports